<template>
    <div>
        <az-break-title title="Serviços Online" />

        <az-empty-state class="mt-3" v-if="( !servicos || !operadora ) && $store.state.loading" />

        <div class="card my-3" v-if="servicos && operadora">
          <div class="card-header">
            <az-input
              class="mt-1"
              type="select"
              v-model="servico"
              :optionsList="servicos"
              optionsDisplay="name" />
          </div>



          <div class="card-body" v-if="servico">
            <div class="mb-2">
                <az-input
                    type="checkbox-group"
                    label="Credenciais por Unidade"
                    v-model="operadora.st_credenciais.porUnidade" />
            </div>

            <div v-if="operadora && operadora.st_credenciais && operadora.st_credenciais.porUnidade" class="mb-2">

                <table class="table table-sm table-responsive-md bg-white mt-3 small">
                <thead>
                    <tr>
                        <th>Unidade</th>
                        <th>Login</th>
                        <th>Senha</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(unidade, idx) in $store.state.unidade.unidade_operacaos" :key="idx">
                        <td class="align-middle">{{unidade.st_nome}}</td>
                        <td>
                            <az-input
                                v-model="operadora.st_credenciais[unidade.id_unidade_operacao + 'login']" />
                        </td>
                        <td>
                            <az-input
                                type="password"
                                icon="fas fa-eye"
                                :buttonIcon="true"
                                buttonText="fas fa-eye"
                                @clickButton="showInfo(operadora.st_credenciais[unidade.id_unidade_operacao + 'senha'])"
                                v-model="operadora.st_credenciais[unidade.id_unidade_operacao + 'senha']"
                                />
                        </td>
                    </tr>
                </tbody>
                </table>
            </div>

            <div v-else class="mb-2" v-for="(item, idx) in servico.credentials" :key="idx">
              <az-input
                class="mt-3"
                v-if="item && item.substr(0,3) == 'fl_'"
                :label="snake2title(item.substr(3))"
                type="checkbox-group"
                v-model="operadora.st_credenciais[item]" />

              <az-input
                v-else-if="item && snake2title(item) == 'Senha'"
                :label="snake2title(item)"
                icon="fas fa-eye"
                :buttonIcon="true"
                buttonText="fas fa-eye"
                @clickButton="itemParaSenha.show_password = !itemParaSenha.show_password"
                :type="itemParaSenha.show_password ? 'text' : 'password'"
                v-model="operadora.st_credenciais[item]" />

              <az-input
                v-else-if="item"
                :label="snake2title(item)"
                v-model="operadora.st_credenciais[item]" />


            </div>
            <div class="mt-3">
              <div class="form-row">
                <div class="col col-12" :class="operadora.fl_servico_elegibilidade ? 'col-md-6' : ''">
                  <az-input
                    type="checkbox-group"
                    label="Elegibilidade"
                    v-model="operadora.fl_servico_elegibilidade" />
                </div>
                <div class="col col-12 col-md-6">
                  <az-input
                    type="checkbox-group"
                    label="Elegibilidade Obrigatória"
                    v-if="operadora.fl_servico_elegibilidade"
                    v-model="operadora.fl_eleg_obrig" />
                </div>
              </div>

              <div class="form-row">
                <div class="col col-12" :class="operadora.fl_servico_autorizacao ? 'col-md-6' : ''">
                    <az-input
                        type="checkbox-group"
                        label="Autorização"
                        v-if="servico.name != 'Coopeder Elegibilidade'"
                        v-model="operadora.fl_servico_autorizacao" />
                </div>
                <div class="col col-6">
                    <az-input
                        type="checkbox-group"
                        label="Autorização Obrigatória"
                        v-if="operadora.fl_servico_autorizacao"
                        v-model="operadora.fl_autoriz_obrig" />
                </div>
              </div>
            </div>

            <pre v-if="false">{{ operadora }}</pre>
          </div>
        </div>

        <!-- Instrução Modal -->
        <div class="modal fade" id="instrucaoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Informação</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                    </div>
                    <div class="modal-body">
                        {{ instrucao }}
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import AzBreakTitle from "../../../util/AzBreakTitle.vue";
import AzInput from '../../../shared/forms/AzInput.vue';
import AzEmptyState from '../../../util/AzEmptyState.vue';

export default {
  data() {
    return {
      dados: null,
      servicos: null,
      servico: null,
      id: null,
      operadora: null,
      instrucao: '',
      itemParaSenha: { show_password: false },
    }
  },

  props: ['id_operadora'],

  components: {
      AzBreakTitle,
      AzInput,
      AzEmptyState,
  },

  watch: {
    servico: {
        handler: function (newValue) {
          if ( this.operadora ) {
            if ( newValue ) {
              if ( !this.operadora.st_credenciais ) {
                this.operadora.st_credenciais = {
                  porUnidade: false,
                };
              }

              this.operadora.id_areport_oper_service = newValue.id;
            }
          }
        },
        immediate: true
    }
  },

  methods: {
    snake2title (texto) {
      return texto.split('_')
              .map(w => w.length > 1 ? w[0].toUpperCase() + w.substr(1).toLowerCase() : w)
              .join(' ');
    },
    atualizar() {
      this.$util.atualizar(this, {
        service: 'operadoras',
        dados: {
          ...this.operadora
        },
        callback: () => {
          this.load();
        },
        toast: true
      });
    },
    load() {

      this.$store.commit('loading', true);

      this.$util.loadItem(this, {
        service: 'operadoras',
        func: 'show',
        id: this.id_operadora,
        parms: {
          service: true,
        }
      })
      .then(res => {
        if ( this.servicos )
          this.servico = this.servicos.find(item => item.id == res.id_areport_oper_service);
        else
          this.servico = null;

        if ( !res.st_credenciais || Array.isArray(res.st_credenciais) ) {
          res.st_credenciais = {
            porUnidade: false
          };
        }

        this.operadora = res;
      })
      .finally(() => {
        this.$store.commit('loading', false);
      });
    },
    showInfo (texto) {
        this.instrucao = texto;

        $('#instrucaoModal').modal('show');
    },
},

  mounted () {
    this.$util.loadItem(this, {
        service: 'acesso_operadoras',
        func: 'index',
      })
      .then(res => {
        this.servicos = res;
        this.load();
      });
  }

}
</script>
